import { mapState } from 'vuex';
import DB from '@/modules/fahrdienst/storeNonReactive';

const fahrdienstMixin = {
  computed: {
    ...mapState('fahrdienst', ['selectedDateLineTrack']),
    instance() {
      return this.$route.params.instance ? Number(this.$route.params.instance) : null;
    },
    dutyId() {
      return this.$route.params.dutyId ? Number(this.$route.params.dutyId) : null;
    },
    dateYYYYMMDD() {
      return this.$route.params.dateYYYYMMDD ? this.$route.params.dateYYYYMMDD : null;
    },
    documentId() {
      return this.$route.params.documentId ? Number(this.$route.params.documentId) : null;
    },
    instanceFiles() {
      return this.$store.state.fahrdienst.files.filter((f) => f.inst === this.instance);
    },
    fahrdienstTypes() {
      return DB.fahrdienstTypes;
    },
    fahrdienstTypeIds() {
      return this.fahrdienstTypes ? this.fahrdienstTypes.map((t) => t.id) : [];
    },
    fahrdienstDutyTypes() {
      return this.fahrdienstTypes ? this.fahrdienstTypes.filter((t) => t.inst === this.instance && t.isFahrdienstType == 1) : [];
    },
    fahrdienstDutyTypeIds() {
      return this.fahrdienstDutyTypes ? this.fahrdienstDutyTypes.map((t) => t.id) : [];
    },
    fahrdienstDutyTypeNames() {
      return this.fahrdienstDutyTypes ? this.fahrdienstDutyTypes.map((t) => t.name).join(', ') : '';
    },
    fahrdienstZirkularTypes() {
      return this.fahrdienstTypes ? this.fahrdienstTypes.filter((t) => t.inst === this.instance && t.isFahrdienstType == 0) : [];
    },
    fahrdienstZirkularTypeIds() {
      return this.fahrdienstZirkularTypes ? this.fahrdienstZirkularTypes.map((t) => t.id) : [];
    },
    fahrdienstZirkularTypeNames() {
      const array = (this.fahrdienstZirkularTypes || []).map((t) => ({
        id: t.id,
        name: t.name,
        sort: t.sort,
      }));
      return array;
    },
  },
};
export default fahrdienstMixin;
